module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageDesert/DIGITAL_CAMOUFLAGE_DESERT_poland.49031ac4.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageDesert/DIGITAL_CAMOUFLAGE_DESERT_poland.png
// module id = 1223
// module chunks = 16